import styled from "styled-components";
import { Link } from "react-router-dom";

export const FooterSection = styled("footer")`
  background: #f8fafc;
  padding: 2.5rem 0;
  border-top: 1px solid #e5e7eb;
`;

export const Title = styled("h4")`
  font-size: 18px;
  text-transform: capitalize;
  color: #0b1220;
  font-weight: 700;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-size: 1rem;
  margin-bottom: 0.625rem;
  transition: all 0.2s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: #2563eb;
  }
`;

export const Extra = styled("section")`
  background: #f8fafc;
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;
`;

export const LogoContainer = styled("div")`
  display: flex;
  position: relative;
`;

export const Para = styled("div")`
  color: #4b5563;
  font-size: 14px;
  width: 70%;
`;

export const Large = styled(Link)<any>`
  font-size: 15px;
  color: #4b5563;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  line-height: 24px;
  display: block;
  margin-bottom: 0.625rem;
  max-width: max-content;

  &:hover {
    color: #2563eb;
  }
`;

export const Chat = styled("p")`
  color: #0b1220;
  max-width: fit-content;
  border-bottom: 1px solid #0b1220;
  cursor: pointer;
  margin-top: 1rem;
  transition: all 0.2s ease-in-out;
  font-weight: 500;

  &:hover {
    border-bottom: 1px solid #2563eb;
    color: #2563eb;
  }
`;

export const Empty = styled("div")`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled("div")`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
  transition: all 0.1s ease-in-out;

  a {
    &:hover,
    &:active,
    &:focus {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
  }

  @media screen and (max-width: 769px) {
    width: auto;

    a:not(:last-child) {
      display: none;
    }
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: #2563eb;
    }
  }
`;

export const Language = styled("h4")`
  font-size: 18px;
  text-transform: capitalize;
  color: #0b1220;
  font-weight: 700;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled("label")`
  font-size: 18px;
  text-transform: capitalize;
  color: #0b1220;
  display: block;
  margin-bottom: 2rem;
  font-family: 'Inter', "Motiva Sans Bold", serif;
  font-weight: 700;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LanguageSwitch = styled("div")<any>`
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    -webkit-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const LanguageSwitchContainer = styled("div")`
  display: flex;
  justify-content: space-between;
  width: 85px;
`;
